import { array, object, string } from 'yup'

import { PRODUCTION_REPORT_STATE } from '@img-arena/consoles-api-streaming'

export const productionReportFormValidationSchema = object().shape({
  event: object().required(),
  issues: array().nonNullable().required('Please define at least one issue.'),
  startDate: string().required('Please select the correct date.'),
  notes: array().optional(),
  state: string().oneOf(Object.values(PRODUCTION_REPORT_STATE))
})
